import React, { useCallback } from 'react';

import { toCanvas } from 'qrcode';

import { useLogger } from 'state/logger';

interface IQRCodeProps {
  barcode: string;
  className?: string;
}

const QRCode = ({ barcode, className }: IQRCodeProps) => {
  const logger = useLogger();
  const canvasRef = useCallback(
    canvasNode => {
      if (canvasNode && barcode) {
        toCanvas(canvasNode, barcode, (err: Error) => {
          if (err) {
            logger.error({ error: err, message: 'Unable to render/decoded barcode string' });
          }
        });
      }
    },
    [barcode, logger]
  );

  return <canvas className={className} ref={canvasRef} />;
};

export default QRCode;
